<template>
  <div>
    <el-row type="flex" class="row-bg">
      <el-col :span="4" :xs="24">
        <el-form-item label="关键词" prop="keyword">
          <el-input v-model="paramsObj.keyword" placeholder="支持款式搜索" @keyup.enter="fetch"
            style="max-width: 120px;"></el-input>
        </el-form-item>
      </el-col>

      <el-col v-if="showOrgFilters" :span="5" :xs="24">
        <el-tree-select ref="companys" v-model="paramsObj.companyId" :data="companys" @change="fetch"
          check-strictly :render-after-expand="false" placeholder="请选择公司" style="width:250px" />
      </el-col>

      <el-col v-if="showOrgFilters" :span="3" :xs="24">
        <el-select v-model="paramsObj.storeCode" placeholder="请选择库房" size="default" @change="fetch" clearable
          style="max-width: 120px;">
          <el-option v-for="item in store" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>
      </el-col>
      <el-col v-if="showOrgFilters" :span="3" :xs="24">
        <el-select v-model="paramsObj.channel" placeholder="渠道" size="default" @change="fetch" clearable
          style="max-width: 120px;">
          <el-option v-for="item in channels" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>
      </el-col>

      <el-col :xs="24" :sm="12" :md="2" :lg="2" :xl="2">
        <el-button style="margin: 0 10px" size="default" type="primary" @click="fetch"> 确认 </el-button>
      </el-col>
    </el-row>

    <div class="chartbox" id="chartbox" style="width:100%; width: 1400px; height: 1100px; margin:10px auto;"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import request from '@/utils/request'
export default {
  name: 'StoreChart',
  data() {
    return {
      paramsObj: {
        keyword: '',
        companyId: '',
        storeCode: '',
        channel: '',
        startDate: '',
        endDate: ''
      },
      companys: [],
      store: [],
      channels: []
    }
  },
  methods: {
    getDefaultCompanyId() {
      if (!this.showOrgFilters) return '*';
      const fromStore = (this.$store.getters.getUserInfo || {}).companyID;
      if (fromStore) return fromStore;
      try {
        const raw = sessionStorage.getItem('userInfo');
        const parsed = raw ? JSON.parse(raw) : {};
        return parsed.companyID || '';
      } catch (e) {
        return '';
      }
    },
    fetch() {
      if (!this.showOrgFilters) {
        this.paramsObj.companyId = '*';
      } else {
        if (!this.companys.length) this.$kaung.companys().then(res => { this.companys = res; });
        if (!this.paramsObj.companyId) this.paramsObj.companyId = this.getDefaultCompanyId();
      }
      if (!this.paramsObj.companyId) {
        this.$message.warning('请选择公司');
        return;
      }
      request({
        url: '/StockStore/StoreTable/',
        method: 'get',
        params: this.paramsObj
      }).then((res) => {
        const datas = res.data;
        const chartDom = document.getElementById('chartbox');
        const myChart = echarts.init(chartDom);
        let option = {
          title: [],
          series: datas.map(function (data, idx) {
            var top = parseInt(idx / 2) * 33;
            return {
              type: 'pie',
              radius: [20, 60],
              top: top + '%',
              height: '300px',
              left: ((idx % 2 * 40) + 10) + '%',
              width: 400,
              itemStyle: { borderColor: '#fff', borderWidth: 1 },
              label: { alignTo: 'edge', formatter: '{name|{b}}\n{time|{c} 元(件)}', minMargin: 5, edgeDistance: 10, lineHeight: 15, rich: { time: { fontSize: 10, color: '#999' } } },
              labelLine: { length: 15, length2: 0, maxSurfaceAngle: 80 },
              labelLayout: function (params) {
                const isLeft = params.labelRect.x < myChart.getWidth() / 2;
                const points = params.labelLinePoints;
                points[2][0] = isLeft ? params.labelRect.x : params.labelRect.x + params.labelRect.width;
                return { labelLinePoints: points };
              },
              data: data
            };
          })
        };
        myChart.setOption(option);
      });
    },
    formatTime(val) {
      return val.getFullYear() + "-" + (val.getMonth() + 1) + "-" + val.getDate();
    }
  },
  mounted() {
    this.$kaung.dictionary('stock', 'store').then(res => this.store = res);
    this.$kaung.dictionary('stock', 'channel').then(res => this.channels = res);
    // 初始化默认时间范围（不设置 date-picker v-model）并自动加载图表数据
    const range = this.$util.getCurrentDate('month');
    if (range && range.length === 2) {
      this.paramsObj.startDate = this.formatTime(range[0]);
      this.paramsObj.endDate = this.formatTime(range[1]) + ' 23:59:59';
    }
  }
}
</script>

<style scoped>
.chartbox { margin-top: 10px; }
</style>

<style lang="less" scoped>
.console-page {
  .el-row {
    margin-bottom: 10px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .box-card {
    margin-bottom: 10px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  h4 {
    margin-top: 5px;

    .number {
      color: #409eff;
    }
  }

  .tableshow {
    img {
      transform: scale(1.3, 1.3);
    }
  }

  .showtext {
    line-height: 20px;
    margin-left: 10px;
  }

  .row-bg {
    .el-col {
      padding: 2px 0;
    }

    padding: 10px 10px;
    background-color: #ffffff;
    border-radius: 5px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }

  .el-date-editor {
    width: 100%;
    max-width: 280px;
  }

  .text-gray {
    font-family: "PingFang SC";
  }

  .el-table th>.cell {
    padding: 0;
    color: #000;
  }

  .el-table .caret-wrapper {
    width: 12px;
    left: -5px;
  }
}

.panel-group .card-panel:hover {
  background: #a9a9a9;
}

.panel-group .card-panel {
  height: 70px !important;
}

.panel-group .card-panel .card-panel-icon-wrapper {
  margin: 10px 0 0 10px !important;
}

.card-panel .card-panel-description {
  margin-top: 10px !important;
}

@media (max-width: 550px) {
  .card-panel-icon-wrapper {
    width: 100%;
    margin: 0 !important;

    .svg-icon {
      display: block;
      margin: 14px auto !important;
      float: none !important;
    }
  }
}
</style>
<style lang="less" scoped>
.console-page {
  .el-row {
    margin-bottom: 10px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .box-card {
    margin-bottom: 10px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  h4 {
    margin-top: 5px;

    .number {
      color: #409eff;
    }
  }

  .tableshow {
    img {
      transform: scale(1.3, 1.3);
    }
  }

  .showtext {
    line-height: 20px;
    margin-left: 10px;
  }

  .row-bg {
    .el-col {
      padding: 2px 0;
    }

    padding: 10px 10px;
    background-color: #ffffff;
    border-radius: 5px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }

  .el-date-editor {
    width: 100%;
    max-width: 280px;
  }

  .text-gray {
    font-family: "PingFang SC";
  }

  .el-table th>.cell {
    padding: 0;
    color: #000;
  }

  .el-table .caret-wrapper {
    width: 12px;
    left: -5px;
  }
}

.panel-group .card-panel:hover {
  background: #a9a9a9;
}

.panel-group .card-panel {
  height: 70px !important;
}

.panel-group .card-panel .card-panel-icon-wrapper {
  margin: 10px 0 0 10px !important;
}

.card-panel .card-panel-description {
  margin-top: 10px !important;
}

@media (max-width: 550px) {
  .card-panel-icon-wrapper {
    width: 100%;
    margin: 0 !important;

    .svg-icon {
      display: block;
      margin: 14px auto !important;
      float: none !important;
    }
  }
}
</style>
